const fhwaData: {
  [key: number]: {
    addedTime: {
      cars: number,
      trucks: number,
      comboTrucks: number
    },
    addedCost: {
      cars: number,
      trucks: number,
      comboTrucks: number
    }
  }
} = {
  0: {
    addedTime: {
      cars: 0,
      trucks: 0,
      comboTrucks: 0
    },
    addedCost: {
      cars: 0.00,
      trucks: 0.00,
      comboTrucks: 0.00
    }
  },
  5: {
    addedTime: {
      cars: 1.02,
      trucks: 0.73,
      comboTrucks: 1.1
    },
    addedCost: {
      cars: 3.66,
      trucks: 12.53,
      comboTrucks: 45.53
    }
  },
  10: {
    addedTime: {
      cars: 1.51,
      trucks: 1.47,
      comboTrucks: 2.27
    },
    addedCost: {
      cars: 11.96,
      trucks: 28.06,
      comboTrucks: 104.95
    }
  },
  15: {
    addedTime: {
      cars: 2,
      trucks: 2.2,
      comboTrucks: 3.48
    },
    addedCost: {
      cars: 20.53,
      trucks: 45.90,
      comboTrucks: 176.02
    }
  },
  20: {
    addedTime: {
      cars: 2.49,
      trucks: 2.93,
      comboTrucks: 4.76
    },
    addedCost: {
      cars: 29.44,
      trucks: 65.55,
      comboTrucks: 257.40
    }
  },
  25: {
    addedTime: {
      cars: 2.98,
      trucks: 3.67,
      comboTrucks: 6.1
    },
    addedCost: {
      cars: 38.83,
      trucks: 86.64,
      comboTrucks: 347.44
    }
  },
  30: {
    addedTime: {
      cars: 3.46,
      trucks: 4.4,
      comboTrucks: 7.56
    },
    addedCost: {
      cars: 48.89,
      trucks: 108.66,
      comboTrucks: 444.50
    }
  },
  35: {
    addedTime: {
      cars: 3.94,
      trucks: 5.13,
      comboTrucks: 9.19
    },
    addedCost: {
      cars: 59.67,
      trucks: 131.21,
      comboTrucks: 546.93
    }
  },
  40: {
    addedTime: {
      cars: 4.42,
      trucks: 5.87,
      comboTrucks: 11.09
    },
    addedCost: {
      cars: 71.37,
      trucks: 154.35,
      comboTrucks: 653.06
    }
  },
  45: {
    addedTime: {
      cars: 4.9,
      trucks: 6.6,
      comboTrucks: 13.39
    },
    addedCost: {
      cars: 84.06,
      trucks: 176.17,
      comboTrucks: 761.31
    }
  },
  50: {
    addedTime: {
      cars: 5.37,
      trucks: 7.33,
      comboTrucks: 16.37
    },
    addedCost: {
      cars: 97.93,
      trucks: 197.68,
      comboTrucks: 870.02
    }
  },
  55: {
    addedTime: {
      cars: 5.84,
      trucks: 8.07,
      comboTrucks: 20.72
    },
    addedCost: {
      cars: 113.04,
      trucks: 217.90,
      comboTrucks: 977.50
    }
  },
  60: {
    addedTime: {
      cars: 6.31,
      trucks: 8.8,
      comboTrucks: 27.94
    },
    addedCost: {
      cars: 129.61,
      trucks: 242.40,
      comboTrucks: 1082.08
    }
  },
  65: {
    addedTime: {
      cars: 6.78,
      trucks: 9.53,
      comboTrucks: 31.61
    },
    addedCost: {
      cars: 147.65,
      trucks: 265.23,
      comboTrucks: 1150.68
    }
  },
  70: {
    addedTime: {
      cars: 7.25,
      trucks: 10.27,
      comboTrucks: 39.48
    },
    addedCost: {
      cars: 167.41,
      trucks: 283.13,
      comboTrucks: 1247.36
    }
  },
  75: {
    addedTime: {
      cars: 7.71,
      trucks: 11,
      comboTrucks: 47.9
    },
    addedCost: {
      cars: 188.97,
      trucks: 304.54,
      comboTrucks: 1344.05
    }
  },
  80: {
    addedTime: {
      cars: 8.17,
      trucks: 11.73,
      comboTrucks: 57.68
    },
    addedCost: {
      cars: 212.42,
      trucks: 325.96,
      comboTrucks: 1440.75
    }
  }
};

export const getFhwaData = function (speed: number) {
  if (fhwaData[speed]) {
    return fhwaData[speed]
  }

  return {
    addedTime: {
      cars: 0,
      trucks: 0,
      comboTrucks: 0
    },
    addedCost: {
      cars: 0,
      trucks: 0,
      comboTrucks: 0
    }
  }
};
